export default "__VITE_ASSET__0d22d582__"